import { AddCustomerForm } from "@/models/payload/customer";
import { phoneNumberValidation } from "@/utilities/validation";
import {
  Button,
  Group,
  SegmentedControl,
  Stack,
  Text,
  TextInput,
} from "@mantine/core";
import { useForm, yupResolver } from "@mantine/form";
import { IconMan, IconWoman } from "@tabler/icons-react";
import * as Yup from "yup";

import { Gender } from "@/models/club";
import useAddCustomer from "@/pages/dashboard/customer/hooks/useAddCustomer";

const schema = Yup.object().shape({
  phoneNumber: Yup.string()
    .required("شماره تلفن را وارد نمایید")
    .matches(phoneNumberValidation, "شماره تلفن را به درستی وارد نمایید"),
  firstName: Yup.string(),
  lastName: Yup.string(),
  referrer: Yup.string().nullable().max(200, "معرف نمی‌تواند بیشتر از ۲۰۰ کاراکتر باشد"),
});

type Props = {
  close: () => void;
  phoneNumber: string;
  refetch: () => void;
};

function AddCustomer({ close, phoneNumber, refetch }: Props) {
  const { addCustomer, isLoading } = useAddCustomer({
    doNavigate: false,
  });

  const form = useForm<AddCustomerForm>({
    initialValues: {
      phoneNumber: phoneNumber,
      firstName: "",
      lastName: "",
      referrer: "",
      birthDate: "",
      dateOfMarriage: "",
      gender: "",
      year: "",
      month: "",
      day: "",
    },
    validate: yupResolver(schema),
  });

  const submit = (values: AddCustomerForm) => {
    addCustomer(
      {
        firstName: values?.firstName,
        lastName: values?.lastName,
        referrer: values.referrer?.trim() || null,
        phoneNumber: values?.phoneNumber,
        gender: !values?.gender
          ? undefined
          : values?.gender === "0"
          ? Gender.Value0
          : Gender.Value1,
      },
      {
        onSuccess() {
          refetch();
          close();
        },
      }
    );
  };

  return (
    <Stack h="440px">
      <Stack
        styles={{
          root: {
            flexGrow: 1,
            overflow: "hidden",
            overflowY: "auto",
          },
        }}
        px="md"
      >
        <form onSubmit={form.onSubmit(submit)}>
          <Stack>
            <TextInput
              size="md"
              placeholder=""
              label="شماره تلفن"
              type="tel"
              dir="ltr"
              readOnly
              styles={{
                input: {
                  textAlign: "left",
                },
              }}
              {...form.getInputProps("phoneNumber")}
            />
            <SegmentedControl
              dir="ltr"
              size="xs"
              data={[
                {
                  label: (
                    <Group justify="center" align="center">
                      <Text size="xs">خانم</Text>
                      <IconWoman size={20} />
                    </Group>
                  ),
                  value: Gender.Value1.toString(),
                },
                {
                  label: (
                    <Group justify="center" align="center">
                      <Text size="xs">آقا</Text>
                      <IconMan size={20} />
                    </Group>
                  ),
                  value: Gender.Value0.toString(),
                },
              ]}
              {...form.getInputProps("gender")}
            />

            <TextInput
              size="md"
              placeholder=""
              label="نام"
              {...form.getInputProps("firstName")}
            />
            <TextInput
              size="md"
              placeholder=""
              label="نام خانوادگی"
              {...form.getInputProps("lastName")}
            />
            <TextInput label="معرف (اختیاری)" maxLength={200} {...form.getInputProps("referrer")} />
            <Button
              type="submit"
              size="md"
              mt="md"
              fullWidth
              loading={isLoading}
            >
              ثبت
            </Button>
          </Stack>
        </form>
      </Stack>
    </Stack>
  );
}

export default AddCustomer;
